<template>
  <div class="w-full">
    <section v-if="!askingConfirmation">
      <h1
        v-if="!submitError && !success"
        class="w-full mb-6 sm:w-3/4 mx-auto text-xl font-semibold"
      >
        How do you wish to advance this {{ type }}?
      </h1>
      <div
        v-if="!submitError && !success"
        class="w-full flex flex-col-reverse sm:flex-row flex-wrap sm:flex-nowrap justify-evenly my-8"
      >
        <VButton
          v-if="availableStates.length === 2"
          :label="displayStatus[availableStates[1]]"
          @click="handleButtonClick(availableStates[1])"
          outlined uppercase class="w-full sm:w-5/12"
          :disabled="chosenStatus === availableStates[1]"
          :submitting-prepend="chosenStatus === availableStates[1]"
        />
        <VButton
          :label="displayStatus[availableStates[0]]"
          @click="handleButtonClick(availableStates[0])"
          uppercase class="w-full mb-2 sm:mb-0"
          :class="availableStates.length === 2 ? 'sm:w-5/12' : 'sm:w-9/12'"
          :disabled="chosenStatus === availableStates[0]"
          :submitting-prepend="chosenStatus === availableStates[0]"
        />
      </div>
      <div v-else-if="success">
        <p class="text-success text-lg font-semibold mx-8 my-4">
          Successfully set status to {{ chosenStatus.replace("_", " ") }}!
        </p>
        <VButton
          label="Close" uppercase
          @click="closePrompt"
          class="mx-auto my-6"
        />
      </div>
      <div v-else>
        <p class="text-danger text-lg font-semibold mx-8 my-4">
          Error changing {{ type.toLowerCase() }} status!
        </p>
        <VButton
          label="Back" uppercase
          @click="submitError = false"
          class="mx-auto my-6"
        />
      </div>
    </section>
    <section v-else>
      <p class="my-8">
        Cancelling this {{ type }} is irreversible.
      </p>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"
import { putPurchaseOrderEdit, putReceiptEdit } from "../../../Site-Track/services/PurchaseOrders"

export default {
  name: "EditStatusPrompt",
  components: {
    VButton
  },
  data() {
    return {
      displayStatus: {
        "APPROVED": "Approve",
        "REJECTED": "Reject",
        "AWAITING": "Await",
        "VENDOR_CONTACT": "Contact Vendor",
        "CANCELED": "Cancel",
        "INCOMPLETE": "Mark as Incomplete",
        "COMPLETED": "Mark as Completed",
        "NEW": "Mark as New"
      },
      chosenStatus: null,
      submitError: false,
      success: false,
      acceptanceOptions: ["Cancel", "Proceed"]
    }
  },
  computed: {
    ...mapState(["headers"]),
    ...mapGetters(["getProceedArgs", "getProceedAction", "isPromptProceed"]),
    id() {
      return this.getProceedArgs.id
    },
    type() {
      return this.getProceedArgs.type
    },
    availableStates() {
      return this.getProceedArgs.states
    },
    askingConfirmation() {
      return this.getProceedArgs.askingConfirmation
    }
  },
  watch: {
    async isPromptProceed (val) {
      if (val === true && this.getProceedAction === "submitConfirmation") {
        this.submitConfirmation()
      }
    },
  },
  methods: {
    ...mapMutations([
      "closePrompt",
      "setRefreshStatus",
      "setPrompt",
      "setPromptSettings",
      "setProceedAction"
    ]),
    handleButtonClick(status) {
      if (status === "CANCELED") {
        this.setPromptSettings({ showCloseBtn: false, hideDefaultButtons: false, keepOpenAfterProceed: true })
        this.setProceedAction(["submitConfirmation", { ...this.getProceedArgs, askingConfirmation: true }])
      }
      else this.setStatus(status)
    },
    submitConfirmation() {
      this.setStatus("CANCELED")
      this.setProceedAction(["submitConfirmation", { ...this.getProceedArgs, askingConfirmation: false }])
      this.setPromptSettings({ header: "none", showCloseBtn: true, hideDefaultButtons: true, keepOpenAfterProceed: false })
    },
    async setStatus(status) {
      this.chosenStatus = status
      let requestBody = {
        status: status,
        siteId: this.headers.siteId
      }
      let endpoint = this.type === "Purchase Order"
        ? putPurchaseOrderEdit(this.id, requestBody, this.headers)
        : putReceiptEdit(this.id, requestBody, this.headers)
      endpoint
      .then(response => {
        if (response.status === 200) {
          this.success = true
          this.setRefreshStatus({ [this.id]: status })
        }
        else {
          console.log(response)
          this.submitError = true
          this.chosenStatus = null
          if (response.status === 403) {
            this.setPrompt(["You do not have the required permissions for this action.", "closePrompt", null, { header: "Error" }])
          }
        }
      }).catch(error => {
        console.log(error)
        this.submitError = true
        this.chosenStatus = null
      })
    }
  },
}
</script>